module.exports = __webpack_public_path__ + "assets/benefits-signup-90fdaf.svg";